import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Merge and purge Tailwind classes using clsx and tailwind-merge
 * This utility prevents class conflicts when using dynamic and conditional classes
 * 
 * @param {...any} inputs - Class names, objects, or arrays to be merged
 * @returns {string} - Merged and purged Tailwind classes
 * 
 * @example
 * // Basic usage
 * cn('px-2 py-1', 'bg-red-500'); // => 'px-2 py-1 bg-red-500'
 * 
 * // With conditional classes
 * cn('px-2', { 'bg-red-500': isError, 'bg-green-500': isSuccess });
 * 
 * // With conflicting classes (last one wins)
 * cn('px-2 py-1 bg-red-500', 'bg-blue-500'); // => 'px-2 py-1 bg-blue-500'
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
} 